const H1Base = ({text, className = ""}) => {
    let finalClass = "text-secondary text-4xl font-bold";

    if (typeof className === "string") {
        finalClass += " " + className;
    }

    return <h1 className={finalClass}>{text}</h1>
}
export default H1Base;